<template>
  <div class="container">
    <div class="item-container">
      <div class="time-box" @click="showCalendar">
        <span class="time-label">提醒日期</span>
        <span class="time-val" :style="{backgroundImage: 'url('+iconUrl+')'}">{{date}}</span>
      </div>
      <textarea v-model="content" placeholder="请输入要提醒的文字" maxlength="50" class="content-box" @blur="
fillScroll" @focus="bottomShow = false" @input="checkInput"></textarea>
      <div class="str-tips" v-if="content.length < 50">还可输入{{50 - content.length}}个字符</div>
      <div class="str-tips" v-else>还可输入0个字符</div>
    </div>
    <button class="btnsave" :class="{'disabled': !date || !content}" @click="addReminder">确认</button>
    <div class="bottom-tip" v-if="bottomShow">
      <h4 class="bottom-tip-title">特别提示</h4>
      <p class="bottom-tip-p">1. 长按日历Home键("O")可显示/隐藏当天的自定义事件提醒。</p>
      <p class="bottom-tip-p">2. 我们将在日历下次联网时为您同步最新事件。如您希望立即同步，请长按日历右键。</p>
    </div>
    <van-calendar
      v-model="calendarShow"
      :min-date="minDate"
      :max-date="maxDate"
      :show-title="false"
      :show-confirm="false"
      :round="false"
      :default-date="defaultDate"
      row-height="56"
      color="#000000"
      @confirm="chooseDate" />
<!--    <canvas id="canvas" width="480" height="176" ref="canvas" style="visibility: hidden"></canvas>-->
<!--    <img :src="img">-->
  </div>
</template>
<script>
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
import Canvas2Image from 'canvas2image'
import axios from 'axios'
import SettingInternet from '../../components/SettingInternet/SettingInternet'

const api = process.env.BASE_URL
const isLocal = Common.getEvn()

export default {
  data () {
    return {
      device_id_ex: '',
      date: '',
      defaultDate: new Date(),
      timestamp: null,
      content: '',
      calendarShow: false,
      iconUrl: Common.staticHref() + 'img/icon_date_arrow.png',
      minDate: new Date(),
      maxDate: new Date(new Date().getFullYear() + 1, new Date().getMonth(), new Date().getDate()),
      img: '',
      bottomShow: true
    }
  },
  components: {
    NavBar,
    MenuList
  },
  methods: {
    showCalendar () {
      this.calendarShow = true
    },
    chooseDate (date) {
      this.calendarShow = false
      this.date = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      this.timestamp = date.getTime() / 1000 - (new Date().getTimezoneOffset() * 60)
      this.fillScroll()
    },
    addReminder () {
      if (!this.date || !this.content) {
        return false
      } else {
        // this.createBmp()
        this.setReminder()
      }
    },
    // createBmp () {
    //   this.toast = this.$createToast({
    //     time: 0,
    //     txt: '正在生成文件',
    //     mask: true
    //   }).show()
    //   const canvas = this.$refs.canvas,
    //     ctx = canvas.getContext('2d'),
    //     // 画布尺寸
    //     all_width = 480,
    //     all_height = 176,
    //     // 左右空白
    //     pad_width = 24,
    //     // 文字区域宽度
    //     txt_width = all_width - 2 * pad_width,
    //     // 文字大小
    //     font_height = 25,
    //     // 文字行高
    //     row_height = 35
    //
    //   let content = this.content,
    //     content_width = ctx.measureText(content).width
    //
    //   ctx.fillStyle = '#ffffff'
    //   ctx.fillRect(0, 0, all_width, all_height)
    //   ctx.font = '' + font_height + 'px sans-serif'
    //   ctx.fillStyle = '#000000'
    //   ctx.textBaseline = 'top'
    //
    //   if (content_width < txt_width) {
    //     // 不足一行，上下左右居中
    //     // 数字字符，measureText的结果比实际宽度小
    //     content_width = content.length * font_height
    //     ctx.fillText(content, (all_width - content_width) / 2, (all_height - 25) / 2)
    //   } else {
    //     // 一行以上，上下居中
    //     let contentArr = content.split(''),
    //       rowNums = Math.ceil(content_width / txt_width),
    //       rowTxt = '',
    //       rowIndex = 0,
    //       positionTop = (all_height - rowNums * row_height) / 2
    //     for (let i = 0; i < contentArr.length; i++) {
    //       rowTxt += contentArr[i]
    //       let rowWidth = ctx.measureText(rowTxt).width
    //       if (rowWidth + font_height > txt_width) {
    //         ctx.fillText(rowTxt, pad_width, positionTop + rowIndex * row_height + (row_height - font_height) / 2)
    //         rowIndex ++
    //         rowTxt = ''
    //       }
    //       else if (i === contentArr.length - 1){
    //         ctx.fillText(rowTxt, pad_width, positionTop + rowIndex * row_height + (row_height - font_height) / 2)
    //       }
    //     }
    //   }
    //
    //   let imgData = Canvas2Image.convertToBMP(canvas).src,
    //     imgFile = this.dataURLtoFile(imgData)
    //   this.toast.hide()
    //   this.img = imgData
    //   this.setReminder(imgFile)
    // },
    // dataURLtoFile (dataurl) {
    //   let arr = dataurl.split(','),
    //     mime = arr[0].match(/:(.*?);/)[1],
    //     bstr = atob(arr[1]),
    //     n = bstr.length,
    //     u8arr = new Uint8Array(n)
    //   while (n--) {
    //     u8arr[n] = bstr.charCodeAt(n);
    //   }
    //   let _blob = new Blob([u8arr], { type: mime })
    //   let filename = '' + new Date().getFullYear() + ('0' + (new Date().getMonth() + 1)).slice(-2) + ('0' + new Date().getDay()).slice(-2) + '.BMP'
    //   let _file = new File([_blob], filename, {type: mime, lastModified: Date.now()})
    //   return _file
    // },
    setReminder (imgFile) {
      let apiUrl = '',
        // apiData = new FormData(),
        apiData,
        that = this
      that.toast = that.$createToast({
        time: 0,
        txt: '正在设置提醒',
        mask: true
      }).show()
      if (isLocal === 'local') {
        apiUrl = '/Calendar/api/device/userdefined/set/reminders/'
      } else {
        apiUrl = api + '/Calendar/api/device/userdefined/set/reminders/'
      }
      // apiData.append('BMP', imgFile)
      // apiData.append('device_id', this.device_id_ex)
      // apiData.append('image_time', this.timestamp)
      // apiData.append('content', this.content)
      apiData = {
        device_id_ex: that.device_id_ex,
        images_time: that.timestamp,
        content: that.content
      }
      axios.post(apiUrl, apiData)
        .then(res => {
          that.toast.hide()
          if (res.data.result === 0) {
            that.toast = this.$createToast({
              txt: '设置成功',
              type: 'txt'
            }).show()
            setTimeout(() => {
              that.$router.go(-1)
            }, 1000)
          } else {
            console.log('添加出错res: ', res)
            that.toast = that.$createToast({
              txt: '上传失败，请稍后再试',
              type: 'txt'
            }).show()
          }
        })
        .catch(err => {
          console.log('添加出错err: ', err)
          that.toast.hide()
          that.toast = that.$createToast({
            txt: '上传失败，请稍后再试',
            type: 'txt'
          }).show()
        })
    },
    fillScroll () {
      let that = this
      setTimeout(() => {
        that.bottomShow = true
      }, 100)
      try {
        window.scroll(0, 0)
      } catch (e) {
        console.log('fillScroll', e)
      }
    },
    checkInput (e) {
      // let val = e.target.value.replace(/\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]/g, '')
      let val = e.target.value.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5\|\.\@\!\#\$\%\^\&\*\(\)\—\-\_\+\=\[\]\{\}\;\:\"\'\?\/\,\<\>\【\】\、\“\”\‘\’\；\：\。\，\《\》\？\~\·\`\……\￥\！\（\）\［\］\ \｛\｝]/g, '')
      // e.target.value = val
      this.content = val
    }
  },
  created () {
    Common.setTitle('提醒详情')
    this.device_id_ex = this.$route.query.iex
    if (this.$route.query.isEdit == 1) {
      let editInfo = JSON.parse(sessionStorage.getItem('max_reminder_edit'))
      let date = new Date((Number(editInfo.image_time) + new Date().getTimezoneOffset() * 60) * 1000)
      this.defaultDate = date
      this.date = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2) + '-' + ('0' + date.getDate()).slice(-2)
      this.timestamp = Number(editInfo.image_time)
      this.content = editInfo.content
    }
  }
}
</script>
<style lang="stylus" scoped>
.container
  position fixed
  top 0
  left 0
.item-container
  position relative
.str-tips
  position absolute
  right 15px
  bottom 15px
  color #F50B0B
  font-size 14px
  line-height 1
.btnsave
  background-color #000000
  margin-top 60px
  margin-left 20px
  width 89.3vw
  height 44px
  font-size 16px
  color #FFFFFF
.btnsave.disabled
  background-color: #ccc;
.bottom-tip
  box-sizing border-box
  border 1px solid #dddddd
  border-radius 5px
  position fixed
  bottom 20px
  left 50%
  transform translate(-50%, 0)
  width 89.3vw
  font-size 12px
  color #000
  padding 25px 15px 10px
.bottom-tip-title
  width 90px
  height 28px
  line-height 28px
  border 1px solid #dddddd
  border-radius 5px
  background-color #ededed
  position absolute
  left 50%
  top 0
  transform translate(-50%, -50%)
  text-align center
  z-index 1
.bottom-tip-p
  line-height 1.5
  margin-bottom 5px
.time-box
  display flex
  align-items center
  color #333
  font-size 14px
  line-height 20px
  justify-content space-between
  padding 0 15px
  height 50px
  background-color #fff
.time-val
  padding-right 10px
  background-size 5px 7px
  background-position right center
  background-repeat no-repeat
  height 20px
.content-box
  font-size 14px
  color #333
  line-height 20px
  padding 15px
  height 180px
  width 100%
  box-sizing border-box
  margin-top 10px
  resize none
</style>



// WEBPACK FOOTER //
// src/pages/ReminderDetail/ReminderDetail.vue